export var MuiChip = {
    styleOverrides: {
        root: {
            height: "fit-content",
            borderRadius: "2px",
            userSelect: "unset",
            fontSize: "1em",
            fontFamily: "inherit",
        },
        label: {
            fontWeight: 500,
            paddingLeft: ".5em",
            paddingRight: ".5em",
            whiteSpace: "normal",
        },
        icon: {
            fontSize: "1em",
        },
        deleteIcon: {
            fontSize: "1em",
            marginLeft: ".1em",
        },
    },
    variants: [
        {
            props: { color: "info" },
            style: function (_a) {
                var theme = _a.theme;
                return ({
                    color: theme.palette.info[700],
                    backgroundColor: theme.palette.info[100],
                    ".MuiChip-deleteIcon": {
                        color: theme.palette.info[600],
                    },
                });
            },
        },
        {
            props: { color: "warning" },
            style: function (_a) {
                var theme = _a.theme;
                return ({
                    color: theme.palette.warning[700],
                    backgroundColor: theme.palette.warning[100],
                    ".MuiChip-deleteIcon": {
                        color: theme.palette.warning[600],
                    },
                });
            },
        },
        {
            props: { color: "default" },
            style: function (_a) {
                var theme = _a.theme;
                return ({
                    color: theme.palette.grey[600],
                    backgroundColor: theme.palette.grey[100],
                    ".MuiChip-deleteIcon": {
                        color: theme.palette.grey[600],
                    },
                });
            },
        },
    ],
};
